export default __webpack_public_path__ + "static/tabs-context-dont-5be68f137dbb022f9bb7f4620fae944667057bf6e597369d8da967a576f33ea0.png";